import { render } from "./submission-tab-empty.vue?vue&type=template&id=35021dd7&scoped=true&ts=true"
import script from "./submission-tab-empty.vue?vue&type=script&lang=ts"
export * from "./submission-tab-empty.vue?vue&type=script&lang=ts"

import "./submission-tab-empty.vue?vue&type=style&index=0&id=35021dd7&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35021dd7"]])

export default __exports__